export function Preloader() {
  return (
    <div className="preloader">
      <img src="/assets/db2.png" className="logoPreloader" />
      <div className="spinner"></div>
    </div>
  )
}
